import { createSelector } from 'reselect'

import { inviteeSelector } from 'selectors/invitee'
import { eventTypeSelector, purchasedPackageSelector } from 'root-api'
import { currentInviteeSelector } from 'selectors/current_invitee'

/**
 * True when the event type expects a payment UI in booking (`has_active_payment_method` from
 * Meetings).
 */
export const isPaymentCheckoutAvailable = (eventType) => (
  Boolean(eventType?.has_active_payment_method)
)

export const shouldCreatePaymentSelector = (state) => {
  if (currentInviteeSelector(state)) return false
  if (purchasedPackageSelector(state)) return false

  if (!isPaymentCheckoutAvailable(eventTypeSelector(state))) return false

  return state.scheduling.payment.status !== 'paid'
}

export const paymentTokenSelector = (state) => {
  // Don't return payment data if part of a purchased package
  const purchasedPackage = purchasedPackageSelector(state)
  if (purchasedPackage) return {}

  const { scheduling: { payment: { data: paymentData } } } = state

  const { payment_method: paymentMethod } = eventTypeSelector(state)

  const paymentDataField = paymentData?.payment_element_flow ? paymentData : (paymentData && {
    token_id: paymentData.id,
    additional_payment_auth_done: paymentData.additional_payment_auth_done,
    payment_source: paymentData.payment_source,
  })

  return {
    ...paymentDataField,
    ...paymentMethod,
  }
}

export const stripeClientSecretSelector = (state) => {
  const { scheduling } = state

  return scheduling?.stripeClientSecret
}

export const stripeAccountSelector = (state) => {
  const { scheduling } = state

  return scheduling?.stripeClientSecret?.stripeAccount
}

export const couponErrorSelector = (state) => {
  const { scheduling } = state
  return scheduling?.coupon
}

export const stripePaymentElementReadyForCaptureSelector = (state) => {
  const { scheduling } = state
  return scheduling?.stripePaymentElementReadyForCapture
}

export const saveFormDataForStripeRedirectSelector = (state) => {
  const { scheduling } = state
  return scheduling?.saveFormDataForStripeRedirect
}

export const chargeSelector = createSelector(
  inviteeSelector,
  ({ charge }) => charge
)

export const chargeCapturedSelector = createSelector(
  chargeSelector,
  (charge) => charge && charge.captured
)
